import React from 'react';
import { motion } from 'framer-motion';
import { Award, BadgeDollarSign, CalendarCheck, ShieldCheck } from 'lucide-react';
const reasons = [{
  icon: Award,
  title: 'Quality Craftsmanship',
  description: "Meticulous attention to detail on every project, every time. We don't cut corners."
}, {
  icon: BadgeDollarSign,
  title: 'Transparent Pricing',
  description: 'Honest quotes with no hidden fees or surprise charges. You know what to expect.'
}, {
  icon: CalendarCheck,
  title: 'On-Time Completion',
  description: 'We respect your schedule, show up when we say we will, and deliver on our promises.'
}, {
  icon: ShieldCheck,
  title: 'Licensed & Insured',
  description: 'Fully licensed, insured, and committed to doing it right for your peace of mind.'
}];
export function WhyChooseUs() {
  return <section className="py-20 md:py-32 bg-charcoal text-white" data-id="element-203">
      <div className="container mx-auto px-4 md:px-6" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16 md:mb-24" data-id="element-205">
          <h2 className="font-heading text-3xl md:text-5xl font-bold tracking-tight mb-4" data-id="element-206">
            Why Homeowners Trust Us
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full" data-id="element-207" />
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8" data-id="element-208">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center group" data-id="element-209">
                <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors border border-white/10 group-hover:border-gold/30" data-id="element-210">
                  <Icon className="w-8 h-8 text-gold" data-id="element-211" />
                </div>
                <h3 className="font-heading text-xl font-bold mb-3" data-id="element-212">
                  {reason.title}
                </h3>
                <p className="text-warmWhite/70 text-base leading-relaxed" data-id="element-213">
                  {reason.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}